export var FAILURE_REASON = /*#__PURE__*/function (FAILURE_REASON) {
  FAILURE_REASON["API_FAIL"] = "api fail";
  FAILURE_REASON["AUP_VIOLATION"] = "aup violation detected";
  FAILURE_REASON["UNKNOWN"] = "unknown fail";
  FAILURE_REASON["TOKEN_LIMIT"] = "token limit fail";
  FAILURE_REASON["INSERT_FAILURE"] = "insert failure";
  FAILURE_REASON["INPUT_TOO_SHORT"] = "input too short fail";
  FAILURE_REASON["HIPAA_CONTENT"] = "hipaa content fail";
  FAILURE_REASON["RATE_LIMITED"] = "rate limited";
  FAILURE_REASON["INTERNAL_SERVER_ERROR"] = "internal server error";
  FAILURE_REASON["ELEVATE_DISABLED_GENERATE"] = "elevate disabled generate";
  return FAILURE_REASON;
}({});